import { styled } from '@creditas-ui/react'
import { compose, withDefaultProps, withForwardRef } from '@creditas/utils'
import React from 'react'

const ProposalHeaderStyle = styled.div`
  display: none;
  color: ${({ theme }) => theme.colors.neutral[90]};
  text-align: left;
  padding: 24px;
  font-size: 14px;
  font-weight: 700;

  @media screen and (min-width: 980px) {
    display: block;
  }
`

const HeaderProposal = styled.div`
  diplay: none;

  @media screen and (min-width: 980px) {
    display: grid;
    grid-template-rows: 2fr;
    grid-column-gap: 20px;
    grid-row-gap: 20px;
    grid-template-columns: repeat(12, 1fr);
    grid-template-areas: "${'warranty '.repeat(1)} ${'name '.repeat(
      3,
    )} ${'cpf '.repeat(2)} ${'step '.repeat(3)} ${'date '.repeat(2)} ${'arrow '}";
  }
`

const propTypes = {}

const defaultProps = {
  component: 'div',
}

const enhancer = compose(
  withForwardRef,
  withDefaultProps(propTypes, defaultProps),
)

const element = enhancer(function ProposalHeader(props) {
  const { testId, headings, withRef, component, className, ...other } = props
  return (
    <HeaderProposal
      data-testid={testId}
      ref={withRef}
      as={component}
      className={className}
      {...other}
    >
      {headings.map((heading, index) => (
        <ProposalHeaderStyle style={{ gridArea: heading.id }} key={index}>
          {heading.title}
        </ProposalHeaderStyle>
      ))}
    </HeaderProposal>
  )
})

export { element as ProposalHeader }
